import { render, staticRenderFns } from "./ProtectionLevelOverview.vue?vue&type=template&id=632f5606&"
import script from "./ProtectionLevelOverview.vue?vue&type=script&lang=js&"
export * from "./ProtectionLevelOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports